import React from 'react'
import styled from 'styled-components'
import uniqid from 'uniqid'
import { assetPrefix } from 'config/env_config'

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-left: 25px;
  position: relative;
  line-height: 1.5;
  font-size: 16px;
  font-family: var(--primary-font);
  font-weight: 600;

  & label {
    font-size: 14px;
    font-weight: 400;
    font-family: var(--primary-font);
    color: var(--gray-5);
  }

  & label:before {
    display: block;
    content: '';
    position: absolute;
    width: 18px;
    height: 18px;
    border: 2px solid ${props => props.hasError ? 'var(--bronze-gold)' : props.color || 'var(--gray-5)'};
    left: 0;
    top: 0;
  }

  & label:after {
    opacity: 0;
    display: block;
    content: '';
    position: absolute;
    width: 18px;
    height: 18px;
    left: 1px;
    top: 1px;
    background-image: url('${assetPrefix}/static/icons/check.svg');
    background-position-y: 1.5rem;
    background-size: 1.5rem;
    background-repeat: none;
    border-radius: 0.3rem;
    transition: all ease .2s;
  }

  input:checked ~ label::after {
    opacity: 1;
  }

  input:checked ~ label::before {
    background: var(--cobasi-blue-light-9);
    border-width: 1px;
  }
`

export const InputStyled = styled.input`
  display: none;
`

const ErrorMessage = styled.div`
  color: var(--bronze-gold);
  font-size: 12px;
  font-family: var(--primary-font);
  padding: 0 16px;
  text-align: start;
`

const Checkbox = ({ label, color, defaultChecked, name, onChangeCallback, errorMessage, children, checked, dataTest }) => {
  const id = uniqid()
  return (
    <>
      <Container data-test='container-checkbox' hasError={!!errorMessage} color={color}>
        <InputStyled
          id={id}
          name={name}
          type='checkbox'
          defaultChecked={defaultChecked}
          checked={checked}
          onChange={onChangeCallback}
          data-test={dataTest}
        />
        <label htmlFor={id}>
          {label}
        </label>
        {children}
      </Container>
      {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
    </>
  )
}

export default Checkbox
